import React from 'react';
import { ArrowLeft } from 'lucide-react';
import AuthHeader from '../AuthHeader';
import AuthField from '../AuthField';
import AuthProgress from '../AuthProgress';
import PasswordStrength from '../PasswordStrength';

// Step 2 of Register V2: password + confirmation. Purely presentational —
// Register.js owns all state/handlers and the strength calculation.
export default function SecurityStep({
  headingRef, password, confirmPassword, errors, loading,
  passwordRequirements, passwordScore,
  onPasswordChange, onConfirmPasswordChange, onBack, onSubmit,
}) {
  return (
    <form onSubmit={onSubmit} noValidate>
      <AuthProgress step={2} totalSteps={2} />
      <AuthHeader
        headingRef={headingRef}
        title="Sécurisez votre compte."
        subtitle="Choisissez un mot de passe robuste pour protéger votre espace."
      />

      <AuthField
        id="register-password"
        label="Mot de passe"
        type="password"
        autoComplete="new-password"
        value={password}
        onChange={onPasswordChange}
        placeholder="Créez un mot de passe sécurisé"
        error={errors.password}
        required
      />
      {password && <PasswordStrength requirements={passwordRequirements} score={passwordScore} />}

      <div style={{ marginTop: 8 }}>
        <AuthField
          id="register-confirm-password"
          label="Confirmer le mot de passe"
          type="password"
          autoComplete="new-password"
          value={confirmPassword}
          onChange={onConfirmPasswordChange}
          placeholder="Répétez votre mot de passe"
          error={errors.confirmPassword}
          required
        />
      </div>

      <div className="auth-stack" style={{ marginTop: 4 }}>
        <button type="submit" className="auth-button auth-button-primary" disabled={loading}>
          {loading ? 'Création du compte…' : 'Créer mon compte'}
        </button>
        <button type="button" className="auth-button auth-button-ghost" disabled={loading} onClick={onBack}>
          <ArrowLeft size={14} aria-hidden="true" /> Retour
        </button>
      </div>
    </form>
  );
}
